let NotificationList = null;

if (__APP_TYPE_CENTRAL__) {
  NotificationList = require('./components/NotificationList').default;
}

export default NotificationList;